/// \file assetGroupRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, Route } from "react-router-dom";

const NewAssetGroupList = lazy(() => import('../views/asset-group-form/list/view'));

export async function newAssetGroupAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/asset-group-form/list/action")).action;
  return actualAction(args);
}


const routes = (
  <Route
    path="AssetGroup"
    handle={{
      text: 'Asset Group'
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <NewAssetGroupList />
        </Suspense>
      }
      action={newAssetGroupAction}
      />
  </Route>
);

export default routes;